import './style.scss';
import './editor.scss';

document.addEventListener( 'DOMContentLoaded', function () {
	/*
	 *	 This move the modals to before </body>
	 */
	const moveModals = document.querySelectorAll( '.filter__modal' );
	if ( moveModals ) {
		moveModals.forEach( ( moveModal ) => {
			document.querySelector( 'body' ).append( moveModal );
		} );
	}
} );

var jQ = jQuery.noConflict();

jQ( document ).ready( function () {
	// jQ( window ).on( 'load', function () {
	// 	jQ( '#modalFilters' ).modal( 'show' );
	// } );

	function closeSelect() {
		jQ( '.multiselect .multiselect__checkboxes' ).each( function () {
			var item = jQ( this );
			if ( item.hasClass( 'active' ) ) {
				item.slideUp( 'fast' );
			}
		} );
	}
	jQ( '.multiselect__selectBox' ).click( function () {
		jQ( this )
			.parent()
			.find( '.multiselect__checkboxes' )
			.removeClass( 'active' );
		closeSelect();
		jQ( this )
			.parent()
			.find( '.multiselect__checkboxes' )
			.addClass( 'active' )
			.slideToggle( 'fast' );
	} );

	jQ( document ).mouseup( function ( e ) {
		if ( jQ( e.target ).closest( '.multiselect' ).length === 0 ) {
			jQ( '.multiselect__checkboxes' )
				.slideUp( 'fast' )
				.removeClass( 'open' );
		}
	} );
} );
